import * as types from './types';

export const getOwners = payload => ({
  type: types.OWNERS_GET_REQUEST,
  payload,
});

export const getOwnerById = (payload) => ({
  type: types.GET_OWNER_BY_ID_REQUEST,
  payload,
});

export const createOrUpdateRequest = payload => ({
  type: types.OWNERS_CREATE_OR_UPDATE_REQUEST,
  payload,
});
